import { types, Instance } from 'mobx-state-tree';
const { model, string, identifier, maybe, number } = types;

export const DepartmentUserModel = model('DepartmentUserModel', {
  dn: identifier,
  uid: maybe(string),
  sn: string,
  givenname: maybe(string),
  mail: maybe(string),
  base: maybe(string),
});

export type IDepartmentUserModel = Instance<typeof DepartmentUserModel>;

export const ManagerModel = model('ManagerModel', {
  user_id: number,
  secondName: maybe(string),
  firstName: maybe(string),
  email: maybe(string),
});
export type IManagerModel = Instance<typeof ManagerModel>;
